var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { toast } from "react-toastify";
import { getComments } from "../../../../api/api";
import { useCommentActions } from "../../../../hooks/actions/useCommentActions";
import { WPQTTypes } from "../../../../types/enums";
import { convertCommentFromServer } from "../../../../utils/comment";
import { CommentsAndLogsTabContent, TabContentCommentItem, } from "../CommentsAndLogsTabContent";
function CommentsTabContent({ taskId }) {
    const { addComment } = useCommentActions();
    const onAddComment = (newEntry) => __awaiter(this, void 0, void 0, function* () {
        const response = yield addComment(taskId, WPQTTypes.Task, true, newEntry);
        if (response) {
            return convertCommentFromServer(response);
        }
    });
    const fetchPrivateComments = () => __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield getComments(taskId, WPQTTypes.Task, true);
            return response.data.map(convertCommentFromServer);
        }
        catch (error) {
            console.error(error);
            toast.error("Failed to load comments");
        }
    });
    return (_jsx(CommentsAndLogsTabContent, { typeId: taskId, fetchData: fetchPrivateComments, onAdd: onAddComment, renderItem: (comment) => (_jsx(TabContentCommentItem, { item: comment })), noDataMessage: "No comments available", explanation: "Comments that can be added and viewed only by WordPress users (with required permissions).", enableAdd: true }));
}
export { CommentsTabContent };
